import React, { useState } from 'react';
import { Card, Col, Row, Form, Button } from 'react-bootstrap';

const GeneralSettings = () => {
  const [companyName, setCompanyName] = useState('');
  const [companyDescription, setCompanyDescription] = useState('');
  const [companyLogo, setCompanyLogo] = useState<File | null>(null);

  const handleSave = () => {
    // Logic to save company settings
    console.log('Company Name:', companyName);
    console.log('Company Description:', companyDescription);
    console.log('Company Logo:', companyLogo);
  };

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header>
              <h4 className="card-title mb-0">General Settings</h4>
            </Card.Header>
            <Card.Body>
              <Form>
                <Form.Group className="mb-3" controlId="companyLogo">
                  <Form.Label>Company Logo</Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const target = e.target as HTMLInputElement;
                      setCompanyLogo(target.files ? target.files[0] : null);
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="companyName">
                  <Form.Label>Company Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="companyDescription">
                  <Form.Label>Company Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={companyDescription}
                    onChange={(e) => setCompanyDescription(e.target.value)}
                  />
                </Form.Group>
                <Button variant="primary" onClick={handleSave}>
                  Save
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default GeneralSettings;
